"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7756],{

/***/ 51285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ EntityMapping; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);

var EntityMapping = {
    /**
   * NODES
   */ NodeArticle: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(8085), __webpack_require__.e(3306), __webpack_require__.e(3588)]).then(__webpack_require__.bind(__webpack_require__, 3588)).then(function(module) {
            return module.Article;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(3588)
                ];
            }
        }
    }),
    NodeHomepage: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 4601).then(__webpack_require__.bind(__webpack_require__, 4601)).then(function(module) {
            return module.Homepage;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(4601)
                ];
            }
        }
    }),
    NodeTopic: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 411).then(__webpack_require__.bind(__webpack_require__, 60411)).then(function(module) {
            return module.Topic;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(60411)
                ];
            }
        }
    }),
    NodeFarmPage: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(426), __webpack_require__.e(8085), __webpack_require__.e(5310), __webpack_require__.e(9289), __webpack_require__.e(5828)]).then(__webpack_require__.bind(__webpack_require__, 71962)).then(function(module) {
            return module.FarmPage;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(71962)
                ];
            }
        }
    }),
    NodeSearchPage: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(426), __webpack_require__.e(9903), __webpack_require__.e(6504), __webpack_require__.e(2539)]).then(__webpack_require__.bind(__webpack_require__, 82539)).then(function(module) {
            return module.SearchPage;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(82539)
                ];
            }
        }
    }),
    NodeFarm: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(426), __webpack_require__.e(2807), __webpack_require__.e(8085), __webpack_require__.e(5310), __webpack_require__.e(3962), __webpack_require__.e(9289), __webpack_require__.e(7575)]).then(__webpack_require__.bind(__webpack_require__, 57575)).then(function(module) {
            return module.Farm;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(57575)
                ];
            }
        }
    }),
    NodePerson: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(2464)]).then(__webpack_require__.bind(__webpack_require__, 2464)).then(function(module) {
            return module.Person;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2464)
                ];
            }
        }
    }),
    /**
   * TEASER
   */ Teaser_image_title: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 7119).then(__webpack_require__.bind(__webpack_require__, 67119)).then(function(module) {
            return module.TeaserImageTitle;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(67119)
                ];
            }
        }
    }),
    Teaser_image_title_text_blue: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 6003).then(__webpack_require__.bind(__webpack_require__, 56003)).then(function(module) {
            return module.TeaserImageTitleText;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(56003)
                ];
            }
        }
    }),
    Teaser_image_title_text_gold: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 6003).then(__webpack_require__.bind(__webpack_require__, 56003)).then(function(module) {
            return module.TeaserImageTitleText;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(56003)
                ];
            }
        }
    }),
    Teaser_list: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(3537)]).then(__webpack_require__.bind(__webpack_require__, 13537)).then(function(module) {
            return module.TeaserList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(13537)
                ];
            }
        }
    }),
    /**
   * PARAGRAPHS
   */ ParagraphText: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(8903)]).then(__webpack_require__.bind(__webpack_require__, 38903)).then(function(module) {
            return module.Text;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(38903)
                ];
            }
        }
    }),
    ParagraphInfoBox: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(1236)]).then(__webpack_require__.bind(__webpack_require__, 21236)).then(function(module) {
            return module.InfoBox;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(21236)
                ];
            }
        }
    }),
    ParagraphImage: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 3260).then(__webpack_require__.bind(__webpack_require__, 3260)).then(function(module) {
            return module.Image;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(3260)
                ];
            }
        }
    }),
    ParagraphTextWithImage: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6762)]).then(__webpack_require__.bind(__webpack_require__, 76762)).then(function(module) {
            return module.TextWithImage;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(76762)
                ];
            }
        }
    }),
    ParagraphSection: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(8201)]).then(__webpack_require__.bind(__webpack_require__, 88201)).then(function(module) {
            return module.Section;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(88201)
                ];
            }
        }
    }),
    ParagraphSectionWithTextImage: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(3539)]).then(__webpack_require__.bind(__webpack_require__, 13539)).then(function(module) {
            return module.SectionWithTextImage;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(13539)
                ];
            }
        }
    }),
    ParagraphHero: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(9903), __webpack_require__.e(161), __webpack_require__.e(6504), __webpack_require__.e(643)]).then(__webpack_require__.bind(__webpack_require__, 10643)).then(function(module) {
            return module.Hero;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(10643)
                ];
            }
        }
    }),
    ParagraphTextHero: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(9903), __webpack_require__.e(161), __webpack_require__.e(6504), __webpack_require__.e(9813)]).then(__webpack_require__.bind(__webpack_require__, 79813)).then(function(module) {
            return module.TextHero;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(79813)
                ];
            }
        }
    }),
    ParagraphTeaserList: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2807), __webpack_require__.e(7442)]).then(__webpack_require__.bind(__webpack_require__, 31237)).then(function(module) {
            return module.TeaserList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(31237)
                ];
            }
        }
    }),
    ParagraphLinks: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 6207).then(__webpack_require__.bind(__webpack_require__, 6207)).then(function(module) {
            return module.Links;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6207)
                ];
            }
        }
    }),
    ParagraphSearchResult: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2807), __webpack_require__.e(7210)]).then(__webpack_require__.bind(__webpack_require__, 15181)).then(function(module) {
            return module.SearchResult;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(15181)
                ];
            }
        }
    }),
    ParagraphFaq: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 8794).then(__webpack_require__.bind(__webpack_require__, 18794)).then(function(module) {
            return module.Faq;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(18794)
                ];
            }
        }
    }),
    ParagraphComment: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(6917)]).then(__webpack_require__.bind(__webpack_require__, 6917)).then(function(module) {
            return module.Comment;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6917)
                ];
            }
        }
    }),
    ParagraphFromLibrary: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 3388).then(__webpack_require__.bind(__webpack_require__, 73388)).then(function(module) {
            return module.FromLibrary;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(73388)
                ];
            }
        }
    }),
    ParagraphFormular: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 9914).then(__webpack_require__.bind(__webpack_require__, 9914)).then(function(module) {
            return module.Formular;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(9914)
                ];
            }
        }
    }),
    ParagraphFarmFarmCategories: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 6172).then(__webpack_require__.bind(__webpack_require__, 46172)).then(function(module) {
            return module.FarmFarmCategories;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(46172)
                ];
            }
        }
    }),
    ParagraphCommentListAndFormular: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(426), __webpack_require__.e(8085), __webpack_require__.e(6464), __webpack_require__.e(2734)]).then(__webpack_require__.bind(__webpack_require__, 2734)).then(function(module) {
            return module.CommentListAndFormular;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2734)
                ];
            }
        }
    }),
    ParagraphHighlightedRating: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 786).then(__webpack_require__.bind(__webpack_require__, 70786)).then(function(module) {
            return module.HighlightedRating;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(70786)
                ];
            }
        }
    }),
    ParagraphFocusTagGlossary: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 8710).then(__webpack_require__.bind(__webpack_require__, 48710)).then(function(module) {
            return module.FocusTagGlossary;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(48710)
                ];
            }
        }
    }),
    ParagraphFarmTeaserList: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2807), __webpack_require__.e(883)]).then(__webpack_require__.bind(__webpack_require__, 5364)).then(function(module) {
            return module.FarmTeaserList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(5364)
                ];
            }
        }
    }),
    ParagraphFileDownload: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(7405)]).then(__webpack_require__.bind(__webpack_require__, 7405)).then(function(module) {
            return module.FileDownload;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(7405)
                ];
            }
        }
    }),
    ParagraphAdSlot: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return __webpack_require__.e(/* import() */ 6604).then(__webpack_require__.bind(__webpack_require__, 16604)).then(function(module) {
            return module.AdSlot;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(16604)
                ];
            }
        }
    }),
    /**
   * FORMULARS
   */ Formular_contact: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(426), __webpack_require__.e(5254)]).then(__webpack_require__.bind(__webpack_require__, 55254)).then(function(module) {
            return module.ContactForm;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(55254)
                ];
            }
        }
    }),
    Formular_comment: next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(426), __webpack_require__.e(6464), __webpack_require__.e(239)]).then(__webpack_require__.bind(__webpack_require__, 30239)).then(function(module) {
            return module.CommentForm;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(30239)
                ];
            }
        }
    })
};


/***/ }),

/***/ 40353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PageContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var PageContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 57756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _path_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/alert/dist/index.esm.js
var dist_index_esm = __webpack_require__(3038);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 55 modules
var modal_dist_index_esm = __webpack_require__(5607);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(35610);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoSearch.js
var IoSearch = __webpack_require__(29354);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoClose.js
var IoClose = __webpack_require__(5981);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./src/graphql/AutocompleteQuery.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AutocompleteArticle on NodeArticle {\n    url\n    tag {\n      title\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AutocompleteFarm on NodeFarm {\n    title\n    url\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Autocomplete($text: String!) {\n    search(text: $text) {\n      total\n      items {\n        ... on NodeArticle {\n          ...AutocompleteArticle\n        }\n        ... on NodeFarm {\n          ...AutocompleteFarm\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var AutocompleteArticleFragment = (0,lib/* gql */.Ps)(_templateObject());
var AutocompleteFarmFragment = (0,lib/* gql */.Ps)(_templateObject1());
var QueryAutocomplete = (0,lib/* gql */.Ps)(_templateObject2(), AutocompleteFarmFragment, AutocompleteArticleFragment);

// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(92706);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/theme/Icons/HorseIcon.tsx
var HorseIcon = __webpack_require__(687);
;// CONCATENATED MODULE: ./src/components/Layout/Search.tsx















var Search = function(param) {
    var inputId = param.inputId;
    var router = (0,next_router.useRouter)();
    var timeoutRef = (0,react.useRef)();
    var ref = (0,react.useState)([]), items = ref[0], setItems = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(QueryAutocomplete, {}), 2), fetchData = ref1[0], ref2 = ref1[1], loading = ref2.loading, data = ref2.data, error = ref2.error;
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            setInputValue("");
            selectItem(null);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, []);
    var stateReducer = (0,react.useCallback)(function(state, actionAndChanges) {
        var type = actionAndChanges.type, changes = actionAndChanges.changes;
        switch(type){
            case downshift_esm/* useCombobox.stateChangeTypes.ItemClick */.Kb.stateChangeTypes.ItemClick:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, changes), {
                    selectedItem: null,
                    inputValue: ""
                });
            default:
                return changes;
        }
    }, []);
    var ref3 = (0,downshift_esm/* useCombobox */.Kb)({
        inputId: inputId,
        stateReducer: stateReducer,
        onInputValueChange: function onInputValueChange(param) {
            var inputValue = param.inputValue;
            if (inputValue && inputValue.length >= 2) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = setTimeout(function() {
                    fetchData({
                        variables: {
                            text: inputValue
                        }
                    });
                }, 500);
            }
        },
        items: items,
        itemToString: function itemToString(item) {
            if (!item) return "";
            if ((item === null || item === void 0 ? void 0 : item.__typename) === "NodeArticle") {
                return item.tag.title;
            }
            return item.title;
        }
    }), isOpen = ref3.isOpen, getMenuProps = ref3.getMenuProps, getInputProps = ref3.getInputProps, getComboboxProps = ref3.getComboboxProps, highlightedIndex = ref3.highlightedIndex, getItemProps = ref3.getItemProps, openMenu = ref3.openMenu, inputValue = ref3.inputValue, setInputValue = ref3.setInputValue, selectItem = ref3.selectItem;
    (0,react.useEffect)(function() {
        var ref;
        setItems((data === null || data === void 0 ? void 0 : (ref = data.search) === null || ref === void 0 ? void 0 : ref.items) || []);
        if (inputValue.length <= 1) {
            setItems([]);
        }
    }, [
        data,
        inputValue
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    var isMenuOpen = isOpen && items.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        pos: "relative",
        flex: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getComboboxProps()), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
                    maxW: "500px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                            bg: "white",
                            border: "0",
                            placeholder: "Suchen...",
                            borderRadius: "sm",
                            borderBottomRadius: isMenuOpen ? 0 : "sm",
                            h: "46px",
                            fontSize: "sm",
                            pl: 4,
                            onFocus: function() {
                                openMenu();
                            }
                        }, getInputProps())),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputRightElement */.xH, {
                            mt: "3px",
                            mr: "3px",
                            width: inputValue.length > 0 || loading ? "5rem" : "2.5rem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    inputValue.length > 0 && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                        bg: "transparent",
                                        color: "primary",
                                        fontSize: "xl",
                                        borderRadius: "sm",
                                        "aria-label": "Search",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IoClose/* IoClose */.b, {}),
                                        onClick: function() {
                                            setInputValue("");
                                            selectItem(null);
                                        },
                                        _hover: {
                                            bg: "transparent",
                                            color: "primaryDark"
                                        },
                                        _active: {
                                            bg: "transparent"
                                        }
                                    }),
                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                        alignItems: "center",
                                        justifyContent: "center",
                                        w: "40px",
                                        h: "40px",
                                        p: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                            color: "primary"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                        bg: "secondary",
                                        color: "white",
                                        fontSize: "xl",
                                        borderRadius: "sm",
                                        "aria-label": "Search",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IoSearch/* IoSearch */.e, {}),
                                        _hover: {
                                            bg: "secondaryDark"
                                        },
                                        _active: {
                                            bg: "secondaryDarker"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getMenuProps()), {
                    pos: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    mt: "-1px",
                    maxW: "500px",
                    zIndex: 12,
                    children: isMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        bg: "#fff",
                        border: "1px solid",
                        borderColor: "gray.400",
                        borderTopColor: "gray.200",
                        borderBottomRadius: "sm",
                        boxShadow: "md",
                        children: items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
                                item: item,
                                index: index
                            })), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        fontWeight: "bold",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        as: "a",
                                        py: 2,
                                        color: "primaryDark",
                                        borderBottomRadius: index === items.length - 1 ? "xl" : 0,
                                        px: 4,
                                        __css: {
                                            bg: highlightedIndex === index && "gray.100"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                overflow: "hidden",
                                                mr: 2,
                                                children: [
                                                    item.__typename === "NodeArticle" ? item.tag.title : item.title,
                                                    item.__typename === "NodeFarm" && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                        ml: 2,
                                                        as: HorseIcon/* HorseIcon */.R
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                as: IoChevronForward/* IoChevronForward */.m
                                            })
                                        ]
                                    })
                                })
                            }), index);
                        })
                    })
                }))
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/MiniMenu.tsx



var MiniMenu = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
        as: "ul",
        listStyleType: "none",
        color: "primary",
        children: data.items.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                as: "li",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: item.url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        px: 4,
                        py: 3,
                        as: "a",
                        fontWeight: "bold",
                        borderRadius: "lg",
                        color: "white",
                        _hover: {
                            bg: "primaryDark"
                        },
                        children: item.title
                    })
                })
            }, i);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronDown.js
var IoChevronDown = __webpack_require__(21370);
;// CONCATENATED MODULE: ./src/components/Layout/Menu.tsx




var Menu = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        as: "nav",
        fontSize: "md",
        mt: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
            mx: -4,
            as: "ul",
            listStyleType: "none",
            justifyContent: "space-between",
            alignItems: "flex-end",
            children: data.items.map(function(item, i) {
                var hasChildren = item.children.length > 0;
                var isLast = i === data.items.length - 1;
                var itemHasLink = item.url && item.url !== "";
                var InnerItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    alignItems: "center",
                    px: 4,
                    py: 4,
                    as: itemHasLink ? "a" : "span",
                    fontWeight: "bold",
                    children: [
                        item.title,
                        " ",
                        hasChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                            ml: 1,
                            as: IoChevronDown/* IoChevronDown */.C
                        })
                    ]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    as: "li",
                    pos: "relative",
                    color: "white",
                    borderTopRadius: "sm",
                    transition: "none",
                    __css: {
                        _hover: {
                            bg: "primaryDark",
                            ".menu-dropdown": {
                                display: "block"
                            }
                        }
                    },
                    children: [
                        itemHasLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: item.url,
                            passHref: true,
                            children: InnerItem
                        }) : InnerItem,
                        hasChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            zIndex: 9,
                            className: "menu-dropdown",
                            display: "none",
                            border: "2px solid",
                            borderColor: "primary",
                            pos: "absolute",
                            left: isLast ? "auto" : "0",
                            right: isLast ? "0" : "auto",
                            top: "100%",
                            bg: "white",
                            color: "primary",
                            shadow: "lg",
                            minW: "200px",
                            borderBottomRadius: "sm",
                            borderTopRightRadius: isLast ? "none" : "sm",
                            borderTopLeftRadius: isLast ? "sm" : "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
                                fontSize: "md",
                                children: item.children.map(function(child, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: child.url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                                borderTopRightRadius: i === 0 && !isLast ? "sm" : "none",
                                                borderTopLeftRadius: i === 0 && isLast ? "sm" : "none",
                                                borderBottomRadius: i === item.children.length - 1 ? "sm" : "none",
                                                px: 4,
                                                py: 2,
                                                alignItems: "center",
                                                as: "a",
                                                whiteSpace: "nowrap",
                                                _hover: {
                                                    bg: "gray.100",
                                                    color: "primaryDark"
                                                },
                                                children: child.title
                                            })
                                        })
                                    }, i);
                                })
                            })
                        })
                    ]
                }, i);
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoMenuOutline.js
var IoMenuOutline = __webpack_require__(44560);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronUp.js
var IoChevronUp = __webpack_require__(43832);
;// CONCATENATED MODULE: ./src/components/Layout/MobileMenu.tsx









var MobileMenuItem = function(param) {
    var data = param.data, onClick = param.onClick;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var hasLink = data.url && data.url !== "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                alignItems: "center",
                justify: "space-between",
                width: "100%",
                fontWeight: "bold",
                children: [
                    hasLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: data.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            onClick: onClick,
                            flex: 1,
                            py: 3,
                            as: "a",
                            display: "block",
                            children: data.title
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        flex: 1,
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        py: 3,
                        as: "span",
                        children: data.title
                    }),
                    data.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        variant: "ghost",
                        borderLeftWidth: "1px",
                        borderLeftColor: "gray.200",
                        borderRadius: "none",
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                            as: isOpen ? IoChevronUp/* IoChevronUp */.A : IoChevronDown/* IoChevronDown */.C
                        })
                    })
                ]
            }),
            isOpen && data.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* List */.aV, {
                ml: 3,
                children: data.children.map(function(child, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: child.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                alignItems: "center",
                                px: 2,
                                py: 2,
                                width: "100%",
                                as: "a",
                                fontWeight: "400",
                                onClick: onClick,
                                children: child.title
                            })
                        })
                    }, i);
                })
            })
        ]
    });
};
var MobileMenu = function(_param) {
    var data = _param.data, onClick = _param.onClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        align: "flex-start",
        divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* StackDivider */.cX, {}),
        fontSize: "md",
        spacing: 0
    }, props), {
        children: data.items.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuItem, {
                data: item,
                onClick: onClick
            }, i);
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/Layout/Header.tsx











var Header = function(param) {
    var data = param.data;
    var ref = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var searchRef = (0,react.useRef)(null);
    var ref1 = (0,hooks_dist_index_esm/* useDisclosure */.qY)(), isOpenSearch = ref1.isOpen, onOpenSearch = ref1.onOpen, onCloseSearch = ref1.onClose;
    (0,hooks_dist_index_esm/* useOutsideClick */.O3)({
        ref: searchRef,
        handler: function() {
            onCloseSearch();
        }
    });
    var onClickToggleSearch = function() {
        if (isOpenSearch) {
            onCloseSearch();
        } else {
            onOpenSearch();
            // Focus search
            var el = document.querySelector("#mobile-search");
            if (el && (0,_instanceof/* default */.Z)(el, HTMLInputElement)) {
                setTimeout(function() {
                    el.focus();
                }, 100);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
                isOpen: isOpen,
                placement: "left",
                onClose: onClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerContent */.sc, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {
                                onClick: onClose
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerHeader */.OX, {
                                children: "Menu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerBody */.Ng, {
                                children: [
                                    data.mainMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
                                        data: data.mainMenu,
                                        onClick: onClose
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                                        borderColor: "gray.400",
                                        my: 4
                                    }),
                                    data.miniMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
                                        data: data.miniMenu,
                                        fontSize: "sm",
                                        onClick: onClose
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                boxShadow: "lg",
                pos: "relative",
                zIndex: 9,
                bg: "primary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        ref: searchRef,
                        display: {
                            base: isOpenSearch ? "block" : "none",
                            md: "none"
                        },
                        shadow: "md",
                        pos: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        bg: "rgba(255,255,255, .6)",
                        p: 4,
                        borderBottom: "1px solid",
                        borderBottomColor: "primary",
                        zIndex: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                            inputId: "mobile-search"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                        maxW: "container.main",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    w: {
                                        base: "80px",
                                        md: "200px"
                                    },
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/logo_secondary.svg",
                                                width: "150px",
                                                alt: "Trabland"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    display: {
                                        base: "flex",
                                        md: "none"
                                    },
                                    flex: 1,
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                            onClick: onClickToggleSearch,
                                            color: "white",
                                            fontSize: "2xl",
                                            variant: "ghost",
                                            "aria-label": "Menu",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                as: IoSearch/* IoSearch */.e
                                            }),
                                            mr: 4
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                            onClick: onOpen,
                                            color: "white",
                                            fontSize: "3xl",
                                            variant: "ghost",
                                            "aria-label": "Menu",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                as: IoMenuOutline/* IoMenuOutline */.l
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    flex: 1,
                                    flexDirection: "column",
                                    pt: 4,
                                    display: {
                                        base: "none",
                                        md: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                    ml: 12,
                                                    mr: -4,
                                                    children: data.miniMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniMenu, {
                                                        data: data.miniMenu
                                                    })
                                                })
                                            ]
                                        }),
                                        data.mainMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                                            data: data.mainMenu
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/config/entity-mapping.ts
var entity_mapping = __webpack_require__(51285);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./src/context/PageContext.ts
var PageContext = __webpack_require__(40353);
;// CONCATENATED MODULE: ./src/hooks/useAdminHeaderIsVisible.ts


function useAdminHeaderIsVisible() {
    var pageContext = (0,react.useContext)(PageContext/* PageContext */.z);
    if (!pageContext.currentUser || pageContext.currentUser.id === 0) {
        return false;
    }
    return true;
};

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiExternalLinkLine.js
var RiExternalLinkLine = __webpack_require__(75367);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
;// CONCATENATED MODULE: ./src/utils/backendUrl.ts

function backendUrl(url) {
    return "".concat(constants/* PUBLIC_RUNTIME_CONFIG.BACKEND_URL */.Ls.BACKEND_URL).concat(url);
};

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiEdit.js
var FiEdit = __webpack_require__(29756);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiLogOut.js
var FiLogOut = __webpack_require__(90143);
;// CONCATENATED MODULE: ./src/components/Layout/AdminHeader.tsx














var AdminHeaderLink = function(_param) {
    var url = _param.url, label = _param.label, icon = _param.icon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "label",
        "icon"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        h: "100%",
        display: "inline-flex",
        alignItems: "center",
        px: 4,
        as: "a",
        href: url,
        target: "_blank",
        _hover: {
            bg: "gray.900"
        },
        transition: "background .2s"
    }, props), {
        children: [
            label,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                ml: 2,
                as: icon
            })
        ]
    }));
};
var AdminHeader = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref, ref1;
    var isVisible = useAdminHeaderIsVisible();
    var pageContext = (0,react.useContext)(PageContext/* PageContext */.z);
    var router = (0,next_router.useRouter)();
    if (!isVisible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        boxShadow: "lg",
        pos: "fixed",
        zIndex: 10,
        top: 0,
        left: 0,
        right: 0,
        bg: "gray.800",
        h: "50px",
        display: "flex",
        color: "#fff",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
            maxW: "container.main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                h: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminHeaderLink, {
                        url: backendUrl("/admin/content"),
                        label: "Administration",
                        icon: RiExternalLinkLine/* RiExternalLinkLine */.u
                    }),
                    ((ref = pageContext.entity) === null || ref === void 0 ? void 0 : ref.entityType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminHeaderLink, {
                        url: backendUrl("/node/".concat((ref1 = pageContext.entity) === null || ref1 === void 0 ? void 0 : ref1.id, "/edit")),
                        label: "Inhalt bearbeiten",
                        icon: FiEdit/* FiEdit */.v,
                        ml: 2,
                        mr: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminHeaderLink, {
                        url: backendUrl("/user/logout"),
                        label: "Abmelden",
                        icon: FiLogOut/* FiLogOut */.x,
                        ml: "auto",
                        target: "_self"
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(23887);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoLocation.js
var IoLocation = __webpack_require__(21929);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/hi/HiPhone.js
var HiPhone = __webpack_require__(74710);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoMailOutline.js
var IoMailOutline = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/utils/scrollToElement.ts
var scrollToElement = __webpack_require__(29556);
;// CONCATENATED MODULE: ./src/components/Layout/Footer.tsx









var FooterMenuItem = function(param) {
    var url = param.url, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            as: "a",
            py: 1.5,
            _hover: {
                textDecoration: "underline"
            },
            children: label
        })
    });
};
var Footer = function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    var context = (0,react.useContext)(PageContext/* PageContext */.z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        bg: "primary",
        pt: {
            base: 16,
            md: 32
        },
        color: "#fff",
        pos: "relative",
        mt: 12,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Img */.Ei, {
                src: "/bottom_wave.svg",
                width: "100%",
                pos: "absolute",
                top: "-1px",
                left: 0,
                right: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                maxW: "container.main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        flexDirection: {
                            base: "column",
                            md: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                mr: {
                                    base: 0,
                                    md: 24
                                },
                                mb: {
                                    base: 4,
                                    md: 0
                                },
                                flexShrink: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Img */.Ei, {
                                    src: "/logo_footer.svg",
                                    width: "250px",
                                    mx: {
                                        base: "auto",
                                        md: 0
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
                                direction: {
                                    base: "column",
                                    md: "row"
                                },
                                spacing: 12,
                                mr: 20,
                                children: (ref = data.footerMenu) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
                                    var ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                fontFamily: "heading",
                                                fontWeight: "bold",
                                                fontSize: "lg",
                                                pb: 2,
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                h: "3px",
                                                bg: "white",
                                                w: "55px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                                flexDir: "column",
                                                pt: 4,
                                                children: (ref = item.children) === null || ref === void 0 ? void 0 : ref.map(function(child, j) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenuItem, {
                                                        url: child.url,
                                                        label: child.title
                                                    }, j);
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            }),
                            (context === null || context === void 0 ? void 0 : context.config) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                mt: {
                                    base: 9,
                                    md: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        fontFamily: "heading",
                                        fontWeight: "bold",
                                        fontSize: "lg",
                                        pb: 2,
                                        children: "KONTAKT"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        h: "3px",
                                        bg: "white",
                                        w: "55px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        flexDir: "column",
                                        pt: 4,
                                        children: [
                                            context.config.address && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                alignItems: "center",
                                                my: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                        fontSize: "2xl",
                                                        as: IoLocation/* IoLocation */.D,
                                                        mr: 2
                                                    }),
                                                    context.config.address
                                                ]
                                            }),
                                            ((ref2 = context.config) === null || ref2 === void 0 ? void 0 : ref2.phone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                alignItems: "center",
                                                my: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                        fontSize: "2xl",
                                                        as: HiPhone/* HiPhone */.J,
                                                        mr: 2
                                                    }),
                                                    context.config.phone
                                                ]
                                            }),
                                            context.config.email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                alignItems: "center",
                                                my: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                        fontSize: "2xl",
                                                        as: IoMailOutline/* IoMailOutline */.W,
                                                        mr: 2
                                                    }),
                                                    context.config.email
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        fontSize: "xs",
                                        children: [
                                            "Trabland.de ist der Betreiber dieses Internetportals und kein Vermittler.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Bitte verwenden Sie unsere Kontaktdaten NICHT f\xfcr Anfragen und Mitteilungen an Reiterh\xf6fe und Reitbetriebe. Nutzen Sie stattdessen bitte die Kontaktdaten dieser Betriebe.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Anfragen \xfcber die Trabland-Kontaktdaten werden nicht an die Betriebe weitergeleitet."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    context.images && Object.keys(context.images).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        alignItems: "flex-start",
                        fontSize: ".65rem",
                        mt: 8,
                        children: [
                            "Fotos:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                                ml: 2,
                                children: Object.keys(context.images).map(function(imageId, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* WrapItem */.Uc, {
                                        children: [
                                            "\xa9 ",
                                            context.images[imageId][0].copyright,
                                            " ",
                                            context.images[imageId].map(function(image, j) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                                    cursor: "pointer",
                                                    onClick: function() {
                                                        (0,scrollToElement/* default */.Z)(".image-".concat(image.id), j);
                                                    },
                                                    pos: "relative",
                                                    ml: 1,
                                                    top: "-2px",
                                                    fontSize: ".65rem",
                                                    children: [
                                                        "#",
                                                        j + 1
                                                    ]
                                                }, j);
                                            }),
                                            i !== Object.keys(context.images).length - 1 && ","
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                mt: 12,
                borderTop: "1px solid",
                borderTopColor: "rgba(255,255,255,.3)",
                py: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                    maxW: "container.main",
                    textAlign: "center",
                    children: "Copyright \xa9 2022 Trabland GmbH"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/utils/log.ts


function log() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (constants/* IS_DEVELOPMENT */.v9) {
        var _console;
        (_console = console).log.apply(_console, (0,_to_consumable_array/* default */.Z)(args));
    }
};

;// CONCATENATED MODULE: ./src/utils/createJsonLd.ts

var LOCAL_BUSINESS = {
    "@type": "LocalBusiness",
    name: "Trabland GmbH",
    image: "",
    "@id": "",
    url: "https://www.trabland.de/",
    telephone: "+49 (0)561 400 85 284",
    email: "info@trabland.de",
    address: {
        "@type": "PostalAddress",
        streetAddress: "Werner-Henschel-Stra\xdfe 2",
        addressLocality: "Fuldatal",
        postalCode: "34233",
        addressCountry: "DE"
    },
    geo: {
        "@type": "GeoCoordinates",
        latitude: 51.3215952,
        longitude: 9.503079999999999
    }
};
function createJsonLd(data) {
    var ref;
    var elements = [];
    if (((ref = data.route) === null || ref === void 0 ? void 0 : ref.__typename) === "NodeArticle") {
        data.route.structuredData.forEach(function(paragraph) {
            if (paragraph.__typename === "ParagraphFaq") {
                var questions = [];
                paragraph.questions.forEach(function(question) {
                    questions.push({
                        "@type": "Question",
                        name: question.question,
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: question.answer
                        }
                    });
                });
                elements.push({
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    mainEntity: questions
                });
            } else if (paragraph.__typename === "ParagraphHowTo") {
                var ref, ref1;
                elements.push({
                    "@type": "HowTo",
                    name: paragraph.headline,
                    tool: (ref = paragraph.tools) === null || ref === void 0 ? void 0 : ref.map(function(tool) {
                        return {
                            "@type": "HowToTool",
                            name: tool
                        };
                    }),
                    step: (ref1 = paragraph.steps) === null || ref1 === void 0 ? void 0 : ref1.map(function(step) {
                        return {
                            "@type": "HowToStep",
                            text: step
                        };
                    })
                });
            }
        });
    }
    return {
        "@context": "https://schema.org",
        "@graph": [
            LOCAL_BUSINESS
        ].concat((0,_to_consumable_array/* default */.Z)(elements))
    };
};

;// CONCATENATED MODULE: ./src/components/Layout/Base.tsx














var Base = function(param) {
    var data = param.data;
    log("base", data);
    var isAdminHeaderVisible = useAdminHeaderIsVisible();
    var EntityComponent = data.route && entity_mapping/* EntityMapping */.f[data.route.__typename];
    var jsonLD = createJsonLd(data);
    log("jsonld", jsonLD);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jsonLD)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(constants/* GA_TRACKING_ID */.vt)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtag",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied'});\n            gtag('set', 'ads_data_redaction', true);\n                \n            gtag('config', '".concat(constants/* GA_TRACKING_ID */.vt, "', {\n              page_path: window.location.pathname,\n            });\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mt: isAdminHeaderVisible ? "50px" : 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        data: data
                    }),
                    data.route && "published" in data.route && !data.route.published && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                            textAlign: "center",
                            maxW: "container.main",
                            py: 9,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Alert */.bZ, {
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                status: "info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AlertTitle */.Cd, {
                                        children: "Information"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AlertDescription */.X, {
                                        children: "Dieser Inhalt ist nicht ver\xf6ffentlicht. Er ist nur f\xfcr eingeloggte Benutzer sichtbar - G\xe4ste sehen diese Seite nicht."
                                    })
                                ]
                            })
                        })
                    }),
                    EntityComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityComponent, {
                        data: data.route
                    }),
                    !data.route && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: "Seite nicht gefunden | Trabland"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                                textAlign: "center",
                                maxW: "container.main",
                                py: 9,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                        as: "h1",
                                        color: "primaryDark",
                                        children: "404 - Seite nicht gefunden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        my: 2,
                                        children: "Die angeforderte Seite konnte nicht gefunden werden."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                            as: "a",
                                            layerStyle: "link_button_blue",
                                            children: [
                                                "Zur\xfcck zur Startseite ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                    ml: 1,
                                                    as: IoChevronForward/* IoChevronForward */.m
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                data: data
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/context/AppContext.ts

var AppContext = (0,react.createContext)({});

// EXTERNAL MODULE: ./node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(24350);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
;// CONCATENATED MODULE: ./src/pages/[...path].tsx






var recursiveLoopContent = function(entity, images) {
    if ("content" in entity) {
        var ref;
        (ref = entity.content) === null || ref === void 0 ? void 0 : ref.forEach(function(paragraph) {
            return recursiveLoopContent(paragraph, images);
        });
    }
    if ("teasers" in entity) {
        var ref1;
        (ref1 = entity.teasers) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(teaser) {
            return recursiveLoopContent(teaser, images);
        });
    }
    if ("teaserImage" in entity) {
        var ref2;
        if ((ref2 = entity.teaserImage) === null || ref2 === void 0 ? void 0 : ref2.copyright) {
            images.push(entity.teaserImage);
        }
    }
    if ("image" in entity) {
        var ref3;
        if ((ref3 = entity.image) === null || ref3 === void 0 ? void 0 : ref3.copyright) {
            images.push(entity.image);
        }
    }
    if ("images" in entity) {
        var ref4;
        (ref4 = entity.images) === null || ref4 === void 0 ? void 0 : ref4.forEach(function(image) {
            if (image.copyright) {
                images.push(image);
            }
        });
    }
    if ("headerImage" in entity) {
        var ref5;
        if ((ref5 = entity.headerImage) === null || ref5 === void 0 ? void 0 : ref5.copyright) {
            images.push(entity.headerImage);
        }
    }
    return images;
};
var PathPage = function(param) {
    var data = param.data, settings = param.settings;
    var ref, ref1, ref2;
    var images = (0,react.useMemo)(function() {
        var images = [];
        var groupedImages = {};
        if (data === null || data === void 0 ? void 0 : data.route) {
            recursiveLoopContent(data.route, images);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var image = _step.value;
                    if (!groupedImages[image.id]) {
                        groupedImages[image.id] = [];
                    }
                    groupedImages[image.id].push(image);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return groupedImages;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContext.Provider, {
        value: {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContext/* PageContext.Provider */.z.Provider, {
            value: {
                currentUser: data.currentUser,
                entity: {
                    entityType: ((ref = data.route) === null || ref === void 0 ? void 0 : ref.entityType) || "",
                    url: ((ref1 = data.route) === null || ref1 === void 0 ? void 0 : ref1.url) || "",
                    id: ((ref2 = data.route) === null || ref2 === void 0 ? void 0 : ref2.id) || 0
                },
                config: data.config,
                images: images,
                adSlots: keyBy_default()(data.adSlotTerms, "key")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Base, {
                data: data
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _path_ = (PathPage);


/***/ }),

/***/ 687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ HorseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52494);


var HorseIcon = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .createIcon */ .IU)({
    viewBox: "0 0 474 360",
    path: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        fill: "currentColor",
        fillRule: "nonzero",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M324,45.32 C324.79688,46.14031 323.19922,46.9177 323.19922,46.9177 C323.19922,46.9177 317.65232,48.5154 316.05862,50.8865 C314.46092,52.4881 312.10942,58.0076 312.10942,58.0076 C315.28132,57.23026 319.25002,56.4099 323.19942,54.8123 C324.0002,54.8123 324.79712,55.63652 325.59392,56.4139 C326.37126,56.4139 316.05482,60.3827 313.70292,61.9373 C312.10522,63.5818 304.18732,69.9217 301.81592,69.9217 C299.44482,69.9217 293.87452,70.69904 293.87452,70.69904 C294.6753,72.29674 295.47222,73.84744 297.02292,76.22244 C297.02292,76.22244 291.49952,79.41774 291.49952,80.19514 C290.72218,81.01545 286.74952,85.76544 286.74952,85.76544 C286.74952,85.76544 301.01552,87.31234 305.76552,79.41774 C301.01552,87.31224 289.92552,95.25374 266.92552,95.25374 C243.14852,95.25374 224.14052,85.76154 211.45652,81.01174 C197.96852,75.48834 180.54252,69.10174 166.27252,69.10174 C152.80752,69.10174 136.95252,73.07054 126.65952,82.60974 C108.42552,75.49254 83.05752,79.41834 71.16352,90.50814 C60.07352,101.59814 48.97952,115.10614 47.38652,124.55914 C45.01542,134.91414 39.46852,159.46514 31.54652,170.60614 C20.43752,188.76614 7.76952,193.55914 3.80052,201.45414 C-0.16828,209.39554 -0.16828,226.05214 0.60912,226.05214 C2.20682,226.82948 7.77322,226.05214 10.94112,224.45054 C17.28882,222.07944 34.69912,203.86854 41.04312,195.14954 C47.38292,186.38784 68.81312,148.33354 71.96512,134.91154 C75.13702,121.44654 78.30492,107.94254 87.82412,100.81754 C98.14012,93.69644 110.78512,96.84874 110.78512,97.66914 C110.78512,97.66914 98.91812,107.16524 98.14012,133.31414 C97.31981,159.45914 113.17912,156.31014 105.25732,172.92714 C97.31982,187.20414 73.56632,177.67324 65.64832,186.38814 C59.30062,193.55224 65.64832,218.88014 65.64832,223.62614 C65.64832,228.41914 63.23422,250.59514 61.67952,256.16514 C60.85921,260.91124 61.67952,264.05964 60.85921,267.25514 C60.08187,269.66924 65.65221,270.40354 65.65221,270.40354 C65.65221,270.40354 60.85921,276.70044 58.48811,275.19264 C56.11701,274.37233 54.53891,274.37233 52.96081,275.19264 C51.36311,275.19264 48.21471,276.70434 45.02331,275.19264 L32.33231,302.12664 C33.93391,302.94695 36.30501,303.68134 38.68001,302.94695 C41.87141,302.12664 57.71501,294.96255 59.30501,293.37275 C61.67611,292.59541 75.14501,284.69695 77.52001,279.95075 C79.11771,275.20075 82.26611,260.10275 82.26611,255.39575 C83.06689,250.60275 83.86381,235.54375 83.86381,231.61875 C83.86381,227.64995 83.06693,220.52875 83.86381,217.33775 C85.46541,214.96665 87.83651,211.76745 91.00831,210.17365 C94.95361,209.39631 99.70361,209.39631 100.50051,209.39631 C102.10211,209.39631 115.58251,210.99401 117.93851,210.99401 C121.11041,210.99401 133.79751,208.62291 136.97351,206.98231 C140.94231,206.24793 143.29771,206.98231 144.11411,208.61901 C145.69221,210.17371 142.51641,212.54481 142.51641,213.36901 C141.73907,214.14245 135.39531,222.08381 133.79761,225.23201 C132.19991,229.20471 126.67651,236.32201 128.27421,239.52101 C129.84841,242.66941 129.84841,243.48981 134.59841,245.90771 C139.36791,247.41551 157.57541,256.99771 167.88741,266.49371 C178.97741,276.72071 189.29341,289.40371 190.89541,295.79471 C193.24311,302.95881 197.21181,303.69311 199.59071,303.69311 C201.98521,304.51342 206.73131,305.29081 206.73131,308.48221 C206.73131,311.63451 205.911,315.60331 205.911,315.60331 L235.255,326.70131 C235.255,326.70131 235.255,316.38131 234.47766,312.45531 C233.67688,307.70531 228.90736,302.95921 224.93466,298.16631 C220.98936,292.59991 179.80166,252.20931 175.80566,249.01831 C171.86036,246.63941 168.66506,243.49101 167.88766,237.15131 C167.06735,230.76461 175.00876,226.06131 179.80166,220.53431 C182.95006,216.56551 191.66866,198.31531 193.24266,195.89731 C194.82076,193.56921 200.38326,187.22151 203.53166,187.22151 C207.50436,187.22151 216.22266,192.79181 227.32866,196.71761 C232.07866,198.31531 266.14466,206.99061 270.93366,208.62761 C275.67976,209.40495 285.94966,208.62761 289.14866,211.77601 C292.29706,214.14711 289.14866,220.53771 288.34788,224.46401 C287.5471,229.21401 278.85178,246.64801 278.85178,246.64801 C278.85178,246.64801 280.42988,252.95271 280.42988,257.78501 C280.42988,263.30841 278.05878,283.11701 275.67988,289.41401 C274.08218,296.57811 262.99188,314.83201 260.59788,317.98401 C259.02368,320.35511 256.65258,321.95671 256.65258,325.92541 C256.65258,329.85121 263.76978,330.71841 266.14478,333.82381 C269.34008,336.23791 266.94556,340.94101 266.14478,345.73381 L297.85978,359.19881 C297.85978,356.82771 299.46138,352.85111 297.85978,351.25741 C297.03947,348.92931 293.11368,344.14021 290.74258,340.94141 C289.14488,338.57031 283.60198,329.85141 282.02378,328.25341 C280.42608,325.92531 280.42608,321.17921 282.02378,317.15541 C282.80112,313.23351 293.11378,286.29641 293.89078,283.10841 C295.48848,279.18261 310.55078,247.42041 312.12478,243.49541 C313.72248,238.74931 326.39078,215.75341 327.98378,211.78041 C329.56188,206.99131 339.87478,203.06161 343.04978,203.06161 C346.99508,203.06161 366.82678,210.18271 369.97978,211.78041 C372.35088,212.55775 390.60878,220.54211 393.75678,222.09641 C397.72948,223.65111 395.35448,226.84641 392.97944,227.66671 C390.60834,229.22141 361.26044,249.02971 358.88544,249.85071 C356.51434,250.62805 354.13934,252.95621 352.53774,252.95621 C350.16664,252.95621 346.99084,255.41711 346.99084,256.19451 C346.99084,257.79221 346.2135,260.94061 342.24474,260.94061 C339.07284,260.94061 332.72914,256.19451 328.77974,251.44451 C323.20944,254.59291 319.26024,257.01481 316.86974,261.71751 C312.92054,265.64331 311.32284,268.88161 308.94784,274.40551 C310.54944,276.00321 313.71734,276.73361 316.06894,276.73361 L341.43994,276.73361 C343.81884,276.73361 346.98684,275.99923 349.38134,275.22191 C351.75244,273.62421 414.35834,232.41291 414.35834,232.41291 C414.35834,232.41291 424.69034,224.47151 424.69034,217.35391 C424.69034,211.78361 419.90124,210.18981 418.35054,207.81481 C415.95604,206.26011 401.69054,196.72481 399.31554,195.16981 C396.12024,192.79871 385.02654,186.40811 381.87754,184.81481 C379.48304,183.26011 370.74454,180.11171 370.74454,180.11171 C373.15864,172.94761 374.73674,167.42071 375.51404,165.82271 C376.33435,164.22501 376.33435,149.93971 377.09214,147.57271 C377.09214,145.24461 381.08434,134.92771 382.65854,133.33071 C384.25624,131.73301 388.22884,119.04971 389.00624,116.67071 C389.82655,115.11601 396.12344,96.86571 399.32224,96.86571 C402.47064,96.08837 405.66204,99.23681 408.81834,99.23681 C412.00974,100.01415 423.87734,98.45947 430.22434,99.23681 C435.79074,100.01415 442.91234,107.17821 444.50534,107.95561 C446.87644,108.77592 452.40374,111.10401 454.00144,111.10401 C454.80222,111.10401 462.72024,105.57671 462.72024,104.02591 C462.72024,102.38921 457.14994,99.23681 456.37254,99.23681 C455.5952,98.45947 450.04834,95.26411 450.04834,95.26411 C450.04834,96.08833 452.40384,93.70941 456.37254,93.70941 C459.54444,93.70941 462.72024,96.86171 463.49364,97.68211 C465.09134,98.45945 469.06004,100.83051 469.83344,99.23681 C470.61078,98.43993 473.78654,94.46731 473.78654,92.09621 C473.78654,88.90481 470.61464,84.97901 469.03654,83.37741 C467.46234,81.77971 449.22754,64.39341 447.63054,63.57241 C445.25944,62.79507 435.76354,54.02941 435.76354,51.70541 C434.94323,50.06091 430.19714,46.13511 429.42374,45.31871 C428.59952,44.54137 404.84974,27.92771 401.67774,25.46671 C398.50584,23.13861 395.33004,19.16981 395.33004,15.20071 C395.33004,11.27491 393.73234,0.95871 393.73234,0.95871 C393.73234,0.95871 388.20894,0.18137 385.81434,2.51341 C383.45884,4.15011 377.89634,16.83741 374.72434,16.83741 C365.98214,15.20071 354.89234,17.61475 354.89234,19.16551 C355.71265,21.53661 363.63064,19.94285 363.63064,19.94285 C363.63064,20.76316 360.45874,24.68895 358.06034,24.68895 C356.48614,24.68895 351.73614,26.28665 350.94314,27.06005 C349.36504,27.06005 346.19314,29.52095 346.19314,29.52095 C348.54864,29.52095 350.94314,29.52095 354.11504,30.25142 C354.11504,30.25142 349.36504,33.44672 346.97054,33.44672 C344.62284,33.44672 336.68154,35.81782 334.30654,36.59512 C332.70884,38.14982 326.36514,42.94282 326.36514,42.94282 L319.24404,42.94282 L320.02138,44.54052 L323.99408,44.54052 L323.986268,45.32177 L324,45.32 Z",
            id: "Path"
        })
    })
});


/***/ }),

/***/ 29556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollToElement; }
/* harmony export */ });
function scrollToElement(selector) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var element;
    if (index === null) {
        element = document.querySelector(selector);
    } else {
        var elements = document.querySelectorAll(selector);
        element = elements.item(index);
    }
    if (element) {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
};


/***/ })

}]);